import React, { ReactNode, createContext, useContext, useState } from 'react';

interface DrawerState {
  isOpen: boolean;
  contentType: 'search' | null;
}

interface SidebarContextState {
  isOpen: boolean;
  subMenuOpen: boolean;
  activeItemId: string | null;
  drawerState: DrawerState;
  toggleSidebar: (shouldOpen?: boolean) => void;
  toggleSubSidebar: (isOpen: boolean) => void;
  setActiveItemId: (id: string | null) => void;
  toggleDrawer: (shouldOpen: boolean, contentType?: 'search' | null) => void;
  isBlurred: boolean;
  setIsBlurred: React.Dispatch<React.SetStateAction<boolean>>;
  homeGlobalSearch : boolean;
  setIsHomeGloablSearch :(value:boolean)=>void;
}

const SidebarContext = createContext<Partial<SidebarContextState>>({});

export const useSidebar = () => useContext(SidebarContext);

export const SidebarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [activeItemId, setActiveItemId] = useState<string | null>(null);
  const [drawerState, setDrawerState] = useState<DrawerState>({ isOpen: false, contentType: null });
  const [isBlurred, setIsBlurred] = useState(true);
  const [homeGlobalSearch, setIsHomeGloablSearch] = useState<boolean>(false)
  

  const toggleSidebar = (shouldOpen?: boolean) => {
    if (shouldOpen) {
      setIsOpen(shouldOpen);
    } else {
      setIsOpen((prev) => !prev);
      toggleSubSidebar(false);
    }
  };

  const toggleSubSidebar = (isOpen: boolean) => setSubMenuOpen(isOpen);
  const setActiveItemIdHandler = (id: string | null) => setActiveItemId(id);

  const toggleDrawer = (shouldOpen: boolean, contentType: 'search' | null = null) => {
    setDrawerState({ isOpen: shouldOpen, contentType });
  };

  return (
    <SidebarContext.Provider value={{
      isOpen,
      subMenuOpen,
      activeItemId,
      toggleSidebar,
      toggleSubSidebar,
      setActiveItemId: setActiveItemIdHandler,
      drawerState,
      toggleDrawer,
      isBlurred,
      setIsBlurred,
      homeGlobalSearch, 
      setIsHomeGloablSearch
    }}>
      {children}
    </SidebarContext.Provider>
  );
};

export default SidebarProvider;
